import type { QueryClient } from '@tanstack/svelte-query';
import { apiFetch } from '$lib/api/client';

export function permanentlyDeleteProduct(id: number) {
  return apiFetch<{ detail: string }>(`/catalogue-management/products/${id}/permanent`, { method: 'DELETE' });
}

// Products, picker results and generated price lists all use the same catalogue.
export async function invalidateProductCatalogue(client: QueryClient) {
  await Promise.all([
    'catalogue-product-list', 'pricelist-select-products', 'catalog-search',
    'search-products', 'catalogue-category-names', 'catalogue-asset-categories',
    'catalog-products', 'catalog-categories', 'catalog-health', 'catalog-issues',
    'catalog-duplicates', 'catalog-analytics'
  ].map((key) => client.invalidateQueries({ queryKey: [key] })));
}
